import React from 'react';
import { ActaUser } from 'pa_kit/apps/user/models/user.js';
import { Badge } from "design-react-kit";

export class CompanyUser extends ActaUser {

    constructor(userData, data){
        super(userData);

        this.role                       = data.role
        this.fiscal_code                = data.fiscal_code
        this.company_name               = data.company_name
        this.company_province           = data.company_province
        this.company_city               = data.company_city        
        this.company_zip_code           = data.company_zip_code
        this.company_address            = data.company_address
        this.description                = data.description
        this.state                      = data.state
        this.created_date               = data.created_date
        this.city_data                  = data.city_data
        this.province_data              = data.province_data
    }   
    
    getState() {
        
        switch(this.state) {
            case 'waiting':
                return <Badge color="warning">In attesa</Badge>;                

            case 'paused':
                return <Badge color="danger">Sospeso</Badge>;

            case 'active':
                return <Badge color="success">Attivo</Badge>;

            default:
                return 'test';
        }
    }

}

export class CompanyInfoPublic {

    constructor(data){
        this.company_name               = data.company_name
        this.company_province           = data.company_province
        this.company_city               = data.company_city
        this.company_zip_code           = data.company_zip_code
        this.company_address            = data.company_address
        this.description                = data.description
    }  
}